import React, { useEffect, useState } from 'react';
import BizScheduler from './BizScheduler.jsx/BizScheduler';


const BizAddNewCourt = () => {
  return (
    <>
      <div className='mb-24'>
        <div className='md:mt-6   container mx-auto'>
          {/* serach bar */}


           

          {/* account pic password and number */}



          {/* My booking in account */}

          


               



              <div className='w-full'>
                <div className='profile-biz-company-profile  '>
                <h1  className='text-2xl  text-[#272C34] font-bold cursor-pointer'><i class="fa-solid fa-arrow-left-long"></i> Add new court</h1> 

                  <div class=" w-full my-2 -mx-3 mb-6">
                    <div class="md:w-[70%] w-full   px-3 mb-6 md:mb-0">
                      <label class="block   tracking-wide text-gray-600 text-xs font-semibold mb-2" htmlFor="grid-first-name">
                        Court name
                      </label>
                      <input class="appearance-none text-gray-400 block w-full rounded-2xl bg-[#fbfeff] h-[50px]  text-gray-700 border border-gray-300 text-xs px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-last-name" type="text" placeholder='Lorem ipsum' />

                    </div>
                    <div class="md:w-[70%] w-full  pt-3 px-3">
                      <label class="block   tracking-wide text-gray-600 text-xs font-semibold " htmlFor="grid-last-name">
                        Court location
                      </label>
                      <div className='flex border border-gray-200 rounded-full'>

                        <input className='w-full bg-[#fbfeff] pl-4 h-12 border border-gray-300  rounded-2xl outline-none reltive   text-xs ' type='text' placeholder='Enter court location' />
                        <div className='bg-blue-100 h-[46px] cursor-pointer mt-[1px] w-20 pt-2 rounded-r-2xl -ml-[81px]'>
                          <i class="fa-solid fa-location-crosshairs text-blue-600 ml-7 text-2xl"></i>

                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <BizScheduler/> 
              </div>








            


        </div>
      </div>
    </>
  )
}

export default BizAddNewCourt